import React, { useState, useEffect } from "react";
import * as S from "./FlowHeader.styles";
import { useNavigate } from "react-router-dom";

interface FlowHeaderProps {
  tags: string[];
  projectId?: string;
  initialName?: string;
}

const FlowHeader: React.FC<FlowHeaderProps> = ({
  tags,
  projectId,
  initialName,
}) => {
  const [title, setTitle] = useState(initialName || "");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setTitle(initialName || "");
  }, [initialName]);


  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.currentTarget.blur();
    }
  };

  const handleCopy = () => {
    navigate("/api");
  };

  return (
    <S.FlowHeaderContainer>
      <S.LeftGroup>
        <S.TitleInput
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="*플로우 제목을 입력해주세요"
          disabled={isLoading || !projectId}
        />
        <S.HashTagList>
          {tags.map((t) => (
            <S.HashTag key={t}>#{t}</S.HashTag>
          ))}
        </S.HashTagList>
      </S.LeftGroup>
      {/* <S.CopyButton onClick={handleCopy}>API 복사 ✦</S.CopyButton> */}
    </S.FlowHeaderContainer>
  );
};

export default FlowHeader;
